import { Memberships } from "@/features/account/memberships";

export const Route = createFileRoute({
  component: Memberships,
});
